/**
 * StickyCartProgress component
 * Handles the cart progress bar functionality, including collapse/expand and cart updates
 */
class StickyCartProgress extends HTMLElement {
  constructor() {
    super();
    
    this.collapseButton = this.querySelector('.cart-progress--collapse-trigger');
    this.progressBar = this.querySelector('.cart-progress--bar-inner');
    this.progressSummary = this.querySelector('.cart-progress--summary');
    this.clickAndCollectVariantId = this.getAttribute('data-click-and-collect-in-cart');
    
    const progressElement = this.querySelector('.cart-progress');
    this.minimumQuantity = progressElement ? 
      parseInt(progressElement.getAttribute('data-minimum-cart-quantity') || '1') : 1;
    
    this.init();
  }

  init() {
    this.bindEvents();
    this.loadSavedState();
    this.updateElementVisibility(); 
  }

  bindEvents() {
    // Handle collapse/expand toggle
    if (this.collapseButton) {
      this.collapseButton.addEventListener('click', () => {
     if (this.hasAttribute('data-collapsed')) {
          this.removeAttribute('data-collapsed');
          localStorage.setItem('cart-progress-collapsed', 'false');
        } else {
          this.setAttribute('data-collapsed', '');
          localStorage.setItem('cart-progress-collapsed', 'true');
        }      
      });
    }

    // Listen for cart updates
    document.addEventListener('cart:update', (event) => this.handleCartUpdate(event));
  }

  /**
   * Load saved collapsed state from localStorage
   */
  loadSavedState() {
    const savedState = localStorage.getItem('cart-progress-collapsed');
    if (savedState === 'true') {
      this.setAttribute('data-collapsed', '');
    } else if (savedState === 'false') {
      this.removeAttribute('data-collapsed');
    }
  }

    updateElementVisibility() {
    const currentCountElement = this.querySelector('[data-cart-progress-count]');
    const minQuantityElement = this.querySelector('[data-min-quantity]');
    const mealsAddedSpan = this.querySelector('.meals-added'); 
    
    if (currentCountElement) {
      const currentCount = parseInt(currentCountElement.textContent || '0');
      
      // Hide count and min quantity if count is 0
      if (currentCount === 0) {
        if (currentCountElement) currentCountElement.style.display = 'none';
        if (minQuantityElement) minQuantityElement.style.display = 'none';
        if (mealsAddedSpan) mealsAddedSpan.style.display = 'none';
      } else {
        if (currentCountElement) currentCountElement.style.display = 'inline';
        if (minQuantityElement) minQuantityElement.style.display = 'inline';
        
        // Only show "meals added" text if count is 3 or more
        if (mealsAddedSpan) {
          mealsAddedSpan.style.display = currentCount >= 3 ? 'inline' : 'none';
        }
      }
    }
  }

  /**
   * Handle cart update events
   * @param {CustomEvent} event - The cart update event
   */
  handleCartUpdate(event) {
    if (!event.detail || !event.detail.data) {
      return;
    }

    const cartData = event.detail.data;
    let currentCount = cartData.itemCount || cartData.item_count || 0;
    //currentCount += parseInt(document.querySelector('[ref="cartBubbleCount"]')?.textContent || '0');
    currentCount = parseInt(document.querySelector('[ref="cartBubbleCount"]')?.textContent || '0');

    const hasClickCollect = cartData.items && cartData.items.some((item) => 
        item.variant_id === this.clickAndCollectVariantId || item.id === this.clickAndCollectVariantId
    );
    
    if (hasClickCollect) {
        currentCount = Math.max(0, currentCount - 1);
    }

    if (this.progressBar) {
        let percentage = Math.min(100, (currentCount / this.minimumQuantity) * 105);
        percentage > 100 ? 100 : percentage;
        // Animate the width change
        if (this.progressBar instanceof HTMLElement) {
          this.progressBar.style.width = `${percentage}%`;
        }
    }

    this.querySelectorAll('[data-cart-progress-count]').forEach((element) => {
      element.innerHTML = currentCount;
    });
    
    this.updateElementVisibility();

  }


  /**
   * Get the current cart data via fetch (fallback method)
   */
  async fetchCartData() {
    try {
      const response = await fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      if (response.ok) {
        const cartData = await response.json();
        const cartUpdateEvent = new CustomEvent('cart:update', {
          detail: { data: cartData }
        });
        this.handleCartUpdate(cartUpdateEvent);
      }
    } catch (error) {
      console.error('Failed to fetch cart data:', error);
    }
  }

}

// Register the custom element
customElements.define('sticky-cart-progress', StickyCartProgress);

// Export for potential use in other modules
export default StickyCartProgress;